import { render, staticRenderFns } from "./request-for-quotes.vue?vue&type=template&id=244ab4ac&scoped=true"
import script from "./request-for-quotes.vue?vue&type=script&lang=js"
export * from "./request-for-quotes.vue?vue&type=script&lang=js"
import style0 from "./request-for-quotes.vue?vue&type=style&index=0&id=244ab4ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244ab4ac",
  null
  
)

export default component.exports